import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Es legal hacer esto yo mismo?',
    a: 'Es 100% legal bajo la Ley de Informes Justos de Crédito (FCRA). Es tu derecho auditar a quien habla mal de tus finanzas.'
  }, {
    q: '¿Funciona si tengo ITIN?',
    a: 'Sí, el sistema de reporte funciona bajo la misma lógica legal tanto para SSN como para ITIN.'
  }, {
    q: '¿Cuánto tiempo tarda en verse el resultado?',
    a: 'Los burós tienen 30 días por ley para responder. La mayoría de nuestros usuarios ven cambios significativos en los primeros 45 días.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionWrapper className="bg-brand-dark" data-id="element-21">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-22">
        <h2 className="text-3xl md:text-4xl font-display uppercase text-center mb-12" data-id="element-23">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, idx) => <div key={idx} className="bg-brand-card border border-gray-800 rounded-xl overflow-hidden" data-id="element-25">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-26">
                <span className="font-bold text-lg text-white pr-4" data-id="element-27">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-cyan transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-28" />
              </button>

              <AnimatePresence data-id="element-29">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-30">
                    <div className="px-6 pb-5 text-gray-400 leading-relaxed border-t border-gray-800/50 pt-4" data-id="element-31">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}